import React, { useEffect, useState } from 'react';
import { Upload, Table, Button, message } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import {API} from "../../../http";
import {NEW_ENDPOINTS} from "../../../http/endpoints";
import {handleFileToBase64} from "../../../utils/helpers";

const CorporateFilesTab = ({ corporateId }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const fetchFiles = async () => {
    try {
      const { data = [] } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.FILE_LIST, {
        corporate_id: corporateId,
      });
      const reversedFiles = data ? [...data].reverse() : [];
      setFiles(reversedFiles);
    } catch (error) {
      message.error('Failed to fetch files');
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleUpload = async ({ file, onSuccess, onError }) => {
    setUploading(true);
    try {
      const fileBase64 = await handleFileToBase64(file);
      await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.UPLOAD_FILE, {
        corporate_id: corporateId,
        filename: file.name,
        content_type: file.type,
        document: fileBase64,
      });
      onSuccess(null, file);
      message.success('File uploaded successfully');
      fetchFiles();
    } catch (error) {
      onError(error);
      message.error('Failed to upload file');
    } finally {
      setUploading(false);
    }
  };

  const handleDownload = async (filename) => {
    try {
      const { data } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.DOWNLOAD_FILE, {
        corporate_id: corporateId,
        filename,
      }, {
        responseType: 'blob',
      });
      const blob = new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Failed to download file');
    }
  };

  const columns = [
    {
      title: 'Filename',
      dataIndex: 'filename',
      key: 'filename',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      align: 'right',
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          onClick={() => handleDownload(record.filename)}
        >
          Download
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Upload
        customRequest={handleUpload}
        showUploadList={false}
        beforeUpload={(file) => {
          const isLt100M = file.size / 1024 / 1024 <= 100;
          if (!isLt100M) {
            message.error('File must be smaller than 100MB');
            return Upload.LIST_IGNORE;
          }
          return true;
        }}
      >
        <Button icon={<UploadOutlined />} loading={uploading}>Upload File</Button>
      </Upload>
      <Table
        dataSource={files}
        columns={columns}
        rowKey="filename"
        pagination={{ position: ['bottomCenter'] }}
        style={{ marginTop: 20, width: '100%' }}
      />
    </div>
  );
};

export default CorporateFilesTab;
